"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const styled_components_1 = __importDefault(require("styled-components"));
const Primary_1 = __importDefault(require("../Primary"));
const SecondaryStyles = (0, styled_components_1.default)(Primary_1.default) `
  color: ${({ theme }) => theme.palette.primary.main};
  background-color: transparent;
  padding: 16px;
  box-shadow: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.gray[0]};
  }

  &:active {
    background-color: transparent;
  }

  &.Mui-disabled:disabled {
    background-color: transparent;
  }
`;
/**
 * _Secondary Button_
 *
 * The secondary button compliments the primary button and placed towards the left of the primary button.
 * The secondary button should not take the form of full sentences.
 *
 * **Scaling for responsive screen size:**
 * The secondary button does not need to fill the full width of the container.
 * When paired with a primary button, the distance between primary and secondary button should be 16px.
 */
const Secondary = (props) => ((0, jsx_runtime_1.jsx)(SecondaryStyles, { touchRippleColor: (0, styles_1.useTheme)().palette.blue[0], ...props }));
exports.default = Secondary;
//# sourceMappingURL=index.js.map